import { useEffect, useState } from "react";

import {
  periscopeNavRedesignEvent,
  periscopeNavRedesignKey,
} from "../../constants/index";

const readPreference = (): boolean =>
  localStorage.getItem(periscopeNavRedesignKey) === "true";

/**
 * Persist the nav-redesign preference and broadcast the change so every
 * consumer of useNavRedesign updates without a page reload. Mirrors the
 * dark-mode toggle pattern in App.tsx.
 */
export const setNavRedesign = (enabled: boolean): void => {
  localStorage.setItem(periscopeNavRedesignKey, `${enabled}`);
  window.dispatchEvent(
    new CustomEvent(periscopeNavRedesignEvent, { detail: { enabled } }),
  );
};

/**
 * Returns whether the user has opted into the redesigned navigation.
 * Defaults to false (existing design) and stays in sync across components.
 */
const useNavRedesign = (): boolean => {
  const [enabled, setEnabled] = useState<boolean>(readPreference);

  useEffect(() => {
    const handleChange = (event: Event) => {
      const detail = (event as CustomEvent<{ enabled?: boolean }>).detail;
      setEnabled(detail?.enabled ?? readPreference());
    };
    window.addEventListener(periscopeNavRedesignEvent, handleChange);
    return () => {
      window.removeEventListener(periscopeNavRedesignEvent, handleChange);
    };
  }, []);

  return enabled;
};

export default useNavRedesign;
